<div mat-dialog-content>
  <p>Are you sure you want to delete this?</p>
</div>
<div mat-dialog-actions class="float-right">
  <button mat-button [mat-dialog-close]="result_false" class="cancel-btn">Cancel</button>
  <button mat-button [mat-dialog-close]="result_true" class="accept-btn">Yes</button>
</div>
